<template>
  <section class="table-section disp-scroll">
    <div class="search-container" style="padding: 8px; border-bottom: 1px solid #ccc;">
      <input 
        v-model="searchQuery" 
        class="input is-small search" 
        placeholder="🔍 ユーザー名、メール、役職、部署で検索"
        style="width: 100%;"
      />
    </div>
    <table class="sended-list-table">
      <tr class="table-header">
        <th class="check">
          <button
            v-if="!isCalendar && batchSelect"
            class="button is-small"
            :class="{'is-primary': !isSelectedAll}"
            style="height: 25px;"
            @click="allSelect">
            {{isSelectedAll ? '全解除' : '全選択'}}
          </button>
        </th>
        <th class="name">名前</th>
        <th class="position">役職</th>
        <th class="department">部署</th>
      </tr>
      <!-- 紐づき済みユーザー群 -->
      <template v-if="linkedUsersFiltered.length > 0">
        <tr class="section-header">
          <td colspan="4" class="section-title">
            <strong>既に設定済みのユーザー ({{ linkedUsersFiltered.length }}名)</strong>
          </td>
        </tr>
        <template v-for="us in linkedUsersFiltered">
          <tr :key="`linked-${us.user_hash}`" :class="{ 'linked-user': true }">
            <td class="check">
              <template v-if="isSingelSelect">
                <CalendarAPIRadioStatus
                  v-if="isCalendar"
                  :user="us"
                  :selfUser="selfUser"
                  :calendarSettings="calendarSettings"
                  :isSync="isSync"
                  :default="default2"
                  :defaultOther="isExistList(us.user_hash, parameterHash)"
                  :isConfirm="isConfirm"
                  :usersStatusAPI="getUsersStatus(us)"
                  @changeShowEventSelf="changeShowEventSelfSelect"
                  @createCalendarSettings="createCalendarSettingsSelect"
                  @changeShowEvent="changeShowEventSelect"
                />
                <b-checkbox
                  v-else
                  :key="us.user_hash"
                  v-model="selectedMember"
                  :native-value="us"
                  class="is-small"
                  style="margin: 4px"
                  :disabled="isConfirm"
                  @input="getUserStatus(us)"
                />
              </template>
              <template v-else>
                <CalendarAPIStatus
                  v-if="isCalendar"
                  :user="us"
                  :selfUser="selfUser"
                  :calendarSettings="calendarSettings"
                  :isSync="isSync"
                  :default="default2"
                  :defaultOther="isExistList(us.user_hash, parameterHash)"
                  :isConfirm="isConfirm"
                  :usersStatusAPI="getUsersStatus(us)"
                  @changeShowEventSelf="changeShowEventSelfSelect"
                  @createCalendarSettings="createCalendarSettingsSelect"
                  @changeShowEvent="changeShowEventSelect"
                />
                <b-checkbox
                  v-else
                  :key="`us-${us.user_hash}`"
                  v-model="selectedMember"
                  :native-value="us"
                  class="is-small"
                  style="margin: 4px"
                  :disabled="isConfirm"
                  @input="getUserStatus(us)"
                />
              </template>
            </td>
            <td class="name">
              <!-- ユーザー名表示：外部から指定可能(slot) -->
              <slot name="username" v-bind:user="us">
                <p style="text-align: left">{{ us.username }}</p>
                <p style="font-size: 8px; text-align: left; color: #808080">
                  {{ us.email }}
                </p>
              </slot>
            </td>
            <td class="position">
              <div v-for="(d, i) in us.positions" :key="i">
                <p>{{ d.name }}</p>
              </div>
            </td>
            <td class="department">
              <div v-for="(d, i) in us.departments" :key="i">
                <p>{{ d.name }}</p>
              </div>
            </td>
          </tr>
        </template>
      </template>

      <!-- 区切り線 -->
      <template v-if="linkedUsersFiltered.length > 0 && unlinkedUsersFiltered.length > 0">
        <tr class="divider-row">
          <td colspan="4" class="divider"></td>
        </tr>
      </template>

      <!-- 全ユーザー群 -->
      <template v-if="unlinkedUsersFiltered.length > 0">
        <tr class="section-header" v-if="linkedUsersFiltered.length > 0">
          <td colspan="4" class="section-title">
            <strong>全ユーザー ({{ unlinkedUsersFiltered.length }}名)</strong>
          </td>
        </tr>
        <template v-for="us in unlinkedUsersFiltered">
          <tr :key="`unlinked-${us.user_hash}`">
            <td class="check">
              <template v-if="isSingelSelect">
                <CalendarAPIRadioStatus
                  v-if="isCalendar"
                  :user="us"
                  :selfUser="selfUser"
                  :calendarSettings="calendarSettings"
                  :isSync="isSync"
                  :default="default2"
                  :defaultOther="isExistList(us.user_hash, parameterHash)"
                  :isConfirm="isConfirm"
                  :usersStatusAPI="getUsersStatus(us)"
                  @changeShowEventSelf="changeShowEventSelfSelect"
                  @createCalendarSettings="createCalendarSettingsSelect"
                  @changeShowEvent="changeShowEventSelect"
                />
                <b-checkbox
                  v-else
                  :key="us.user_hash"
                  v-model="selectedMember"
                  :native-value="us"
                  class="is-small"
                  style="margin: 4px"
                  :disabled="isConfirm"
                  @input="getUserStatus(us)"
                />
              </template>
              <template v-else>
                <CalendarAPIStatus
                  v-if="isCalendar"
                  :user="us"
                  :selfUser="selfUser"
                  :calendarSettings="calendarSettings"
                  :isSync="isSync"
                  :default="default2"
                  :defaultOther="isExistList(us.user_hash, parameterHash)"
                  :isConfirm="isConfirm"
                  :usersStatusAPI="getUsersStatus(us)"
                  @changeShowEventSelf="changeShowEventSelfSelect"
                  @createCalendarSettings="createCalendarSettingsSelect"
                  @changeShowEvent="changeShowEventSelect"
                />
                <b-checkbox
                  v-else
                  :key="`us-${us.user_hash}`"
                  v-model="selectedMember"
                  :native-value="us"
                  class="is-small"
                  style="margin: 4px"
                  :disabled="isConfirm"
                  @input="getUserStatus(us)"
                />
              </template>
            </td>
            <td class="name">
              <!-- ユーザー名表示：外部から指定可能(slot) -->
              <slot name="username" v-bind:user="us">
                <p style="text-align: left">{{ us.username }}</p>
                <p style="font-size: 8px; text-align: left; color: #808080">
                  {{ us.email }}
                </p>
              </slot>
            </td>
            <td class="position">
              <div v-for="(d, i) in us.positions" :key="i">
                <p>{{ d.name }}</p>
              </div>
            </td>
            <td class="department">
              <div v-for="(d, i) in us.departments" :key="i">
                <p>{{ d.name }}</p>
              </div>
            </td>
          </tr>
        </template>
      </template>
    </table>
  </section>
</template>

<script>
import CalendarAPIStatus from "@/views/DashBoard/Calendar/CalendarAPIStatus";
import CalendarAPIRadioStatus from "@/views/DashBoard/Calendar/CalendarAPIRRadioStatus";
export default {
  name: "SelectMemberTable",
  componentName: "SelectMemberTable",
  props: {
    users: {
      type: Array,
    },
    parameterHash: {
      type: Array,
    },
    calParameter: {
      type: Object,
    },
    calendarSettings: {
      type: Array,
      require: true,
    },
    selfUser: {
      type: Object,
      require: true,
    },
    isCalendar: {
      type: Boolean,
      require: false,
    },
    isSync: {
      type: Boolean,
    },
    default2: {
      type: Boolean,
    },
    batchSelect: {
      type: Boolean,
    },
    isSingelSelect: {
      type: Boolean,
    },
    narrow: {
      type: Function,
    },
    isConfirm: {
      type: Boolean,
      require: false,
    },
    usersStatusAPI: {
      type: Array,
      require: true,
    }
  },
  components: {
    CalendarAPIStatus,
    CalendarAPIRadioStatus,
  },
  data: function () {
    return {
      selectedMember: [],
      getCalList: [],
      searchQuery: '',
    }
  },
  computed: {
    linkedUsersFiltered() {
      let dispUsers = this.getBaseFilteredUsers()
      
      // Get linked users
      let linkedUsers = dispUsers.filter(user => 
        this.parameterHash && this.parameterHash.includes(user.user_hash)
      )
      
      // Apply search filter
      if (this.searchQuery && this.searchQuery.trim()) {
        const query = this.searchQuery.toLowerCase().trim()
        linkedUsers = linkedUsers.filter(user => this.matchesSearch(user, query))
      }
      
      return linkedUsers
    },
    
    unlinkedUsersFiltered() {
      let dispUsers = this.getBaseFilteredUsers()
      
      // Get unlinked users
      let unlinkedUsers = dispUsers.filter(user => 
        !this.parameterHash || !this.parameterHash.includes(user.user_hash)
      )
      
      // Apply search filter
      if (this.searchQuery && this.searchQuery.trim()) {
        const query = this.searchQuery.toLowerCase().trim()
        unlinkedUsers = unlinkedUsers.filter(user => this.matchesSearch(user, query))
      }
      
      return unlinkedUsers
    },
    
    showUsers () {
      // Return combined list for compatibility with existing logic
      return [...this.linkedUsersFiltered, ...this.unlinkedUsersFiltered]
    },
    isSelectedAll () {
      const allVisibleUsers = [...this.linkedUsersFiltered, ...this.unlinkedUsersFiltered]
      return allVisibleUsers.length > 0 && allVisibleUsers.every(user => 
        this.selectedMember.some(selected => selected.user_hash === user.user_hash)
      )
    }
  },
  watch: {
    selectedMember () {
      this.$emit('sendMember', this.selectedMember)
    },
  },
  methods: {
    allSelect() {
      const allVisibleUsers = [...this.linkedUsersFiltered, ...this.unlinkedUsersFiltered]
      if (this.isSelectedAll) {
        // 一括解除：表示中のユーザーを選択から除外
        this.selectedMember = this.selectedMember.filter(user => 
          !allVisibleUsers.some(visibleUser => visibleUser.user_hash === user.user_hash)
        )
      } else {
        // 一括選択：表示中のユーザーを追加（削除ユーザーチェック付き）
        const newSelections = allVisibleUsers.filter(user => 
          !this.selectedMember.some(selected => selected.user_hash === user.user_hash)
        )
        const oldMember = this.selectedMember
        const candidateMembers = [...this.selectedMember, ...newSelections]
        
        // 削除ユーザーがいないか確認
        const user_hash = candidateMembers.map(user => user.user_hash)
        this.selectedMember = candidateMembers
        this.isActive(user_hash)
      }
    },
    allCancel() {
      this.selectedMember = []
    },
    isExistList(userHash, list) {
      return list && list.includes(userHash);
    },
    changeShowEventSelfSelect(userHash) {
      // 削除ユーザーがいないか確認
      this.isActive([userHash])
      this.$emit("changeShowEventSelfSelectMember", userHash)
    },
    createCalendarSettingsSelect(data) {
      // 削除ユーザーがいないか確認
      this.isActive([data.user.user_hash])
      this.$emit("createCalendarSettingsSelectMember", data)
    },
    changeShowEventSelect(cs) {
      // 削除ユーザーがいないか確認
      this.isActive([cs.calendar_user.user_hash])
      this.$emit("changeShowEventSelectMember", cs)
    },
    getUsersStatus(u) {
      for (let us of this.usersStatusAPI) {
        if (u.user_hash === us.user_hash) {
          return us
        }
      }
    },
    getUserStatus(us) {
      if (this.selectedMember.find((user) => user.user_hash === us.user_hash)) {
        this.isActive([us.user_hash])
      }
    },
    isActive(userHashList) {
      // 選択されているユーザーの状態だけ取得する
      const data = {
        get_calendar_status: this.isCalendar,
        get_delete_status: true,
        hash_list: userHashList,
      }
      this.$store.dispatch('auth/getSelectedUsersStatusAPI', data)
      .then((status_list) => {
        // 返ってきたエラーユーザーの情報を、アラートで表示する
        if (status_list.length > 0) {
          let userList = []
          for (const status of status_list) {
            if (status.status === 'none' || status.status === 'error') {
              userList.push('　・' + status.user_name + '：' + status.type.replace('\n', ''))
            }
          }
          if (userList.length > 0) {
            if (this.isCalendar) {
              alert('以下のユーザーは、カレンダー連携されていないか、または削除されています。\nブラウザのリロードをお願いいたします。\n\n' + userList.join('\n'))
            } else {
              alert('以下のユーザーは削除されています。\nブラウザのリロードをお願いいたします。\n\n' + userList.join('\n'))
            }
          }
        }
      })
    },
    
    getBaseFilteredUsers() {
      let dispUsers = null
      if (this.isCalendar) {
        // カレンダー関連で使用する場合はログイン不可ユーザーを表示しない
        dispUsers = this.users.filter(user => {return user.permission < 3})
      } else {
        dispUsers = this.users
      }
      
      // Apply narrow filter if provided
      if (this.narrow) {
        dispUsers = dispUsers.filter((user) => {return this.narrow(user)})
      }
      
      return dispUsers
    },
    
    matchesSearch(user, query) {
      // Search in username
      if (user.username && user.username.toLowerCase().includes(query)) {
        return true
      }
      // Search in email
      if (user.email && user.email.toLowerCase().includes(query)) {
        return true
      }
      // Search in positions
      if (user.positions && user.positions.some(pos => pos.name && pos.name.toLowerCase().includes(query))) {
        return true
      }
      // Search in departments
      if (user.departments && user.departments.some(dept => dept.name && dept.name.toLowerCase().includes(query))) {
        return true
      }
      return false
    },
    
    isLinkedUser(userHash) {
      return this.parameterHash && this.parameterHash.includes(userHash)
    }
  },
};
</script>

<style scoped>
.table-section {
  width: 100%;
  height: 100%;
  overflow: auto;
  border: 1px #ccc solid;
  white-space: nowrap;
}
.sended-list-table {
  font-size: 12px;
  width: 100%;
}
.sended-list-table::-webkit-scrollbar {
  width: 5px;
}
th,
td {
  padding: 8px;
}
.check {
  width: 10%;
  text-align: center;
  vertical-align: middle;
}
.name {
  text-align: center;
  width: 50%;
  vertical-align: middle;
}
.position {
  text-align: center;
  width: 20%;
  vertical-align: middle;
}
.department {
  text-align: center;
  width: 20%;
  vertical-align: middle;
}

.linked-user {
  background-color: #e8f4fd !important;
  border-left: 4px solid #007bff;
}

.linked-user:hover {
  background-color: #d1ecf1 !important;
}

.section-header {
  background-color: #f8f9fa !important;
}

.section-title {
  padding: 12px 8px !important;
  font-size: 14px;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
  text-align: left;
}

.divider-row {
  height: 8px;
}

.divider {
  background: linear-gradient(to right, #dee2e6 0%, #dee2e6 100%);
  height: 2px;
  border: none;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/tables/SelectMemberTable.vue